// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/stylesheets/variables.css
// module id = 5
// module chunks = 0